import { SecurityElementNames } from './../../../shared/auth/constants/security-element-names.service';
import { AccessControlEntry } from './../../../shared/auth/access-control-entry';
import { MenuItem } from 'primeng/api';
import { Component, OnInit, Input, AfterViewInit, AfterViewChecked, OnChanges, ViewChild } from '@angular/core';
import { ProfileMin } from '../../../profiles/shared/profile-min.model';
import { UtilService, DialogService, NotificationService, DatagridService } from '../../../shared/index';
import { EventRead } from '../../shared/event-read.model';
import { RegistrationRead } from '../shared/crud/registration-read.model';
import { RegistrationUpsert } from '../shared/crud/registration-upsert.model';
import { RegistrationAttendee } from '../shared/registration-attendee.model';
import { RegistrationAttendeeItem } from '../shared/registration-attendee-item.model';
import { RegistrationAttendeeItemCustomResponse } from '../shared/registration-attendee-item-custom-response.model';
import { RegistrationItem } from '../shared/registration-item.model';
import { RegistrationItemCustomField } from '../shared/registration-item-custom-field.model';
import { RegistrationItemCustomFieldAvailableValue } from '../shared/registration-item-custom-field-avail-value.model';
import { RegistrationItemCustomFieldAvailableValueCreditType } from '../shared/registration-item-custom-field-avail-value-credit-type.model';
import { EventItemService } from '../../shared/items/event-item.service';
import { EventItemSummary } from '../../shared/items/event-item-summary.model';
import { TranslationService } from '../../../shared/translation/translation.service';
import { RegistrationService } from '../../registration/shared/registration.service';
import { RegistrationSearchParams } from '../../registration/shared/registration-search-params.model';
import { RegistrationSearchResult } from '../../registration/shared/registration-search-result.model';
import { Router, ActivatedRoute } from '@angular/router';
import { EventsService } from '../../shared/events.service';
import { RegistrationMin } from '../shared/registration-min.model';
import { RegistrationAttendeeMin } from '../shared/registration-attendee-min.model';
import { NameValue } from '../../../shared/model/name-value.model';
import { RegistrationDeleteComponent } from '../delete/registration-delete.component';
import { DialogResult } from '../../../shared/dialog/dialog-result.model';
import { RegistrationManagementSelectorComponent } from './selector/registration-management-selector.component';
import { AffCodeMassAddComponent } from '../../../affcode/affcode-mass-add/affcode-mass-add.component';
import {
  WlEventsToolbarBroadcastService,
  WlEventsToolbarEventTypeEnum,
} from '../../../shared/container/toolbars/module/events/broadcast/index';
import { DataView as PrimeDataList } from 'primeng/dataview';
import { NavigationService } from '../../../shared/navigation/navigation.service';
import { PlatformService } from '../../../shared/platform/platform.service';
import { timeoutWrapper } from 'src/app/shared/decorator/timeout-wrapper';
import { EventTabsEnum } from '../../shared/event-tabs.enum';

@Component({
  selector: 'wl-registration-management',
  templateUrl: 'registration-management.component.html',
  styleUrls: ['registration-management.component.css'],
  providers: [RegistrationService, EventItemService],
    standalone: false
})
export class RegistrationManagementComponent implements OnInit, AfterViewInit {
  @ViewChild('registrationSelector', { static: false }) registrationSelector: RegistrationManagementSelectorComponent;
  @ViewChild('registrationsDataGrid', { static: false }) public _registrationsDataGrid: PrimeDataList;
  @ViewChild('deleteDialog', { static: false }) public deleteDialog: RegistrationDeleteComponent;

  public _route: ActivatedRoute;
  public _routerService: Router;
  public _utilService: UtilService;
  public _dialogService: DialogService;
  public _notifyService: NotificationService;
  public _registrationService: RegistrationService;
  public _eventItemService: EventItemService;
  public _translationService: TranslationService;
  public _dataGridService: DatagridService;
  public _eventService: EventsService;
  public _registrationToDelete: RegistrationMin;

  public registrationSearchResult: RegistrationSearchResult;
  public unfilteredRegistrationSearchResult: RegistrationSearchResult = new RegistrationSearchResult();
  @Input() public event: EventRead;

  public initialLoadComplete: boolean;
  public searchParams: RegistrationSearchParams;
  public eventId: number;
  public showDetails: boolean;
  public showAdvancedSearch: boolean;
  public eventItems: Array<EventItemSummary>;
  public sortByFields: Array<NameValue>;
  public isSearching: boolean;
  public selectedAction: number;
  public actions: Array<NameValue>;
  public exporting: boolean;
  public launchedModal: boolean;
  public registrationItemMenuItems: MenuItem[];
  public editInvoiceAccessControl: AccessControlEntry = {
    SecurityElement: this._securityElementNames.Revenue_Module,
    MinimumAccessLevel: 2,
  };

  public constructor(
    routerService: Router,
    eventService: EventsService,
    route: ActivatedRoute,
    utilService: UtilService,
    eventItemService: EventItemService,
    translationService: TranslationService,
    registrationService: RegistrationService,
    dialogService: DialogService,
    dataGridService: DatagridService,
    notifyService: NotificationService,
    public _eventsToolbarBroadcastService: WlEventsToolbarBroadcastService,
    public _platformService: PlatformService,
    public _navigationService: NavigationService,
    private _securityElementNames: SecurityElementNames
  ) {
    this._route = route;
    this._routerService = routerService;
    this._eventService = eventService;
    this._utilService = utilService;
    this._registrationService = registrationService;
    this._eventItemService = eventItemService;
    this._translationService = translationService;
    this._dialogService = dialogService;
    this._dataGridService = dataGridService;
    this._notifyService = notifyService;
    this._registrationToDelete = new RegistrationMin();

    this.event = new EventRead();
    this.initialLoadComplete = false;
    this.registrationSearchResult = new RegistrationSearchResult();
    this.searchParams = new RegistrationSearchParams();
    this.searchParams.PageNumber = 1;
    this.searchParams.PageSize = 20;

    this.eventId = 0;
    this.showDetails = false;
    this.showAdvancedSearch = false;
    this.eventItems = new Array<EventItemSummary>();
    this.sortByFields = new Array<NameValue>();
    this.isSearching = false;
    this.selectedAction = 0;
    this.actions = new Array<NameValue>();
    this.exporting = false;
  }

  ngOnInit() {
    // setup sortby dropdown
    let nv1 = new NameValue();
    let nv2 = new NameValue();
    let nv3 = new NameValue();
    let nv4 = new NameValue();
    let nv5 = new NameValue();
    let nv6 = new NameValue();
    let nv7 = new NameValue();
    let nv8 = new NameValue();
    let nv9 = new NameValue();
    let nv10 = new NameValue();

    nv1.name = 'Sign Up Date (desc)';
    nv1.value = 'SignUpDate:desc';
    nv2.name = 'Sign Up Date (asc)';
    nv2.value = 'SignUpDate:asc';

    nv3.name = 'Org Name (asc)';
    nv3.value = 'OrgName:asc';
    nv4.name = 'Org Name (desc)';
    nv4.value = 'OrgName:desc';

    nv5.name = 'First Name (asc)';
    nv5.value = 'FirstName:asc';
    nv6.name = 'First Name (desc)';
    nv6.value = 'FirstName:desc';

    nv7.name = 'Last Name (asc)';
    nv7.value = 'LastName:asc';
    nv8.name = 'Last Name (desc)';
    nv8.value = 'LastName:desc';

    nv9.name = 'Amount Due (asc)';
    nv9.value = 'AmountDue:asc';
    nv10.name = 'Amount Due (desc)';
    nv10.value = 'AmountDue:desc';

    this.sortByFields.push(nv1);
    this.sortByFields.push(nv2);
    this.sortByFields.push(nv3);
    this.sortByFields.push(nv4);
    this.sortByFields.push(nv5);
    this.sortByFields.push(nv6);
    this.sortByFields.push(nv7);
    this.sortByFields.push(nv8);
    this.sortByFields.push(nv9);
    this.sortByFields.push(nv10);

    // setup actions dropdown
    this._translationService.getTitlecase('events.registration.management.actions.select-action').then((data: string) => {
      this.actions.push(new NameValue(data, 0));
    });

    this._translationService.getTitlecase('events.registration.management.actions.export-all-registrations').then((data: string) => {
      this.actions.push(new NameValue(data, 1));
    });

    this._translationService.getTitlecase('events.registration.management.actions.send-confirmation-email').then((data: string) => {
      this.actions.push(new NameValue(data, 2));
    });

    this._translationService.getTitlecase('events.registration.management.actions.view-print-all-invoices').then((data: string) => {
      this.actions.push(new NameValue(data, 3));
    });

    this._translationService.getTitlecase('events.registration.management.actions.view-print-open-invoices').then((data: string) => {
      this.actions.push(new NameValue(data, 4));
    });
    this._translationService
      .getTitlecase('events.registration.management.actions.add-selected-profiles-to-affiliation')
      .then((data: string) => {
        this.actions.push(new NameValue(data, 5));
      });
    this._translationService.getTitlecase('events.registration.management.actions.email-these-registrations').then((data: string) => {
      this.actions.push(new NameValue(data, 6));
    });
    this._translationService.getTitlecase('events.registration.management.actions.apply-payments').then((data: string) => {
      this.actions.push(new NameValue(data, 7));
    });
    this._translationService
      .getTitlecase('events.registration.management.actions.export-all-registrations-extended')
      .then((data: string) => {
        this.actions.push(new NameValue(data, 8));
      });
    this._translationService
      .getTitlecase('events.registration.management.actions.export-all-registrations-extended-excel')
      .then((data: string) => {
        this.actions.push(new NameValue(data, 10));
      });
    this._translationService
      .getTitlecase('events.registration.management.actions.export-selected-registrations-extended')
      .then((data: string) => {
        this.actions.push(new NameValue(data, 9));
      });
  }

  /**
   * called after view is initted. all view children are ready
   */
  public ngAfterViewInit(): void {
    this._route.params.subscribe((params: any) => {
      if (this._utilService.isNotNullOrUndefined(params['id'])) {
        this.eventId = Number(params['id']);
        this.searchParams.EventId = this.eventId;

        //this.resetAndSearch();
        //do not reset just search as other compopnents like EventSettings will set some params
        //like looking for only ProfileId == 0 etc
        this.search();

        this._eventService.getEventRead(this.eventId).then((data: EventRead) => {
          this.event = data;
        });

        this._eventItemService.getEventItems(this.eventId).then((data: Array<any>) => {
          for (let item of data) {
            item.Selected = false;
          }

          this.eventItems = data;
        });
      }
    });
  }

  public lazyLoadRegistrations = ($event: any): void => {
    if (this.initialLoadComplete == true && this.isSearching == false) {
      this._dataGridService.mapDatagridPagingToPagedSearch($event, this.searchParams);
      this.getRegistrations();
    }
  };

  /**
   * starts the search over at page 1
   */
  @timeoutWrapper()
  public search() {
    // datalist doesn't offer a reset() method like datatable
    (<any>this._registrationsDataGrid).first = 0;
    //this._registrationsDataGrid.updatePaginator();
    this.searchParams.PageNumber = 1;
    this.searchParams.PageSize = 20;
    this.getRegistrations();
  }

  public getRegistrations = (): void => {
    this.searchParams.EventItemIds = new Array<number>();
    this.updateAttendeeTotals();

    for (let item of <any>this.eventItems) {
      if (item.Selected == true) {
        this.searchParams.EventItemIds.push(item.EventItemId);
      }
    }

    if (this.searchParams.EventId > 0) {
      this.isSearching = true;
      this._registrationService.searchRegistrations(this.searchParams).then(
        (data: RegistrationSearchResult) => {
          this._dataGridService.mapPagedResultsToPagedSearch(data, this.searchParams);

          this.registrationSearchResult = data;

          for (let reg of this.registrationSearchResult.Result) {
            reg.Selected = false;
            reg.UnkownAttendeesCount = Math.max(reg.PotentialAttendeeCount - reg.AttendeeCount + reg.BlankAttendeeCount, 0);
            this.initRegistrationMenu(reg);
          }
          this.initialLoadComplete = true;
          this.isSearching = false;
        },
        () => {
          this.isSearching = false;
        }
      );
    }
  };

  public toggleDetails(registration: RegistrationMin): void {
    if (!registration) return;

    if (registration.ShowDetails) this.closeDetails(registration);
    else this.openDetails(registration);
  }

  public openDetails = (registration: RegistrationMin): void => {
    registration.LoadingDetails = true;
    registration.ShowDetails = true;
    this._registrationService.getRegistrationAttendeeHeaders(registration.Id).then(
      (data: Array<RegistrationAttendeeMin>) => {
        registration.Attendees = data;
        registration.LoadingDetails = false;
      },
      () => {
        registration.LoadingDetails = false;
      }
    );
  };
  public closeDetails = (registration: RegistrationMin): void => {
    registration.ShowDetails = false;
  };

  public editRegistration = (registration: RegistrationMin): void => {
    this.launchedModal = true;
    this._eventsToolbarBroadcastService.broadcast({
      type: WlEventsToolbarEventTypeEnum.editRegistration,
      data: { EventId: this.event.EventId, RegistrationId: registration.Id },
    });
    this._eventsToolbarBroadcastService.subscribe((x) => {
      if (x.type == WlEventsToolbarEventTypeEnum.registrationSaved || x.type == WlEventsToolbarEventTypeEnum.registrationClosed)
        this.launchedModal = false;
    });
  };

  public viewInvoice = (registration: RegistrationMin): void => {
    console.error(registration);
    this._registrationService.getInvoiceReport(registration.InvoiceNum).then((url) => this._navigationService.popupSafeNavigate(url));
  };

  public toggleAdvancedSearch = (): void => {
    if (this.showAdvancedSearch) this.closeAdvancedSearch();
    else this.openAdvancedSearch();
  };

  public openAdvancedSearch = (): void => {
    this.showAdvancedSearch = true;
  };

  public closeAdvancedSearch = (): void => {
    this.showAdvancedSearch = false;
  };

  public deleteRegistration = (registration: RegistrationMin): void => {
    this._registrationToDelete = registration;
    this.deleteDialog.showDialog(
      registration.Id,
      registration.InvoiceNum,
      registration.AmountPaid > 0,
      registration.HasRefundableCCPayment
    );
  };

  public registrationDeleteDialogHandler = (result: DialogResult): void => {
    if (result == DialogResult.Yes) {
      this._dialogService.showWaitIndicator();

      this._registrationService.deleteRegistration(this._registrationToDelete.Id, this.deleteDialog.modificationOptions).then(
        (data: any) => {
          //remove from list
          this._utilService.arrayRemoveEntry(this.registrationSearchResult.Result, this._registrationToDelete);
          this._dialogService.closeWaitIndicator();
        },
        (error) => {
          this._dialogService.closeWaitIndicator();
          if (error) {
            this._dialogService.error(error);
          }
        }
      );
    }
  };

  public actionChanged = (data: string): void => {
    this.selectedAction = parseInt(data);
  };

  public executeAction = (): void => {
    this.registrationSelector.selectedAction = this.selectedAction;
    //this.registrationSelector.registrations = this.registrationSearchResult.Result;
    //this.registrationSelector.registrationSearchResult = this.registrationSearchResult;
    this.registrationSelector.searchParams = this.searchParams;
    this.registrationSelector.searchRegistrations();

    this.registrationSelector.eventId = this.eventId;

    switch (this.selectedAction) {
      case 0:
        break;

      case 1:
        this.exporting = true;
        this._registrationService.exportRegistrations(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.exporting = false;
          },
          () => {
            this.exporting = false;
          }
        );
        break;

      case 2:
        this.registrationSelector.showDialog(this.selectedAction);
        break;

      case 3:
        this.exporting = true;
        this._registrationService.printAllEventInvoices(this.eventId).then(
          (url) => {
            this.exporting = false;
            this._navigationService.popupSafeNavigate(url);
          },
          (err) => (this.exporting = false)
        );
        break;

      case 4:
        this._registrationService.printOpenEventInvoices(this.eventId).then(
          (url) => {
            this.exporting = false;
            this._navigationService.popupSafeNavigate(url);
          },
          (err) => (this.exporting = false)
        );
        break;

      case 5:
        this.registrationSelector.showDialog(this.selectedAction);
        break;

      case 6:
        this.registrationSelector.showDialog(this.selectedAction);
        break;

      case 7:
        this.registrationSelector.registrations = this.registrationSelector.registrations.filter((x) => x.AmountPaid < x.AmountInvoiced);
        this.registrationSelector.showDialog(this.selectedAction);

        break;

      case 8:
        this.exporting = true;
        this._registrationService.exportRegistrationsExtended(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.exporting = false;
          },
          () => {
            this.exporting = false;
          }
        );
        break;

      case 10:
        this.exporting = true;
        this._registrationService.exportRegistrationsExtendedAsExcel(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.exporting = false;
          },
          () => {
            this.exporting = false;
          }
        );
        break;
      case 9:
        this.registrationSelector.eventId = this.eventId;
        this.registrationSelector.showDialog(this.selectedAction);
        break;

      default:
        break;
    }
  };

  public registrationSaved = (event: any): void => {
    this.getRegistrations();
  };

  public searchEventItemFromDashboard(eventItemId: number): void {
    this.openAdvancedSearch();

    for (let item of <any>this.eventItems) {
      if (item.EventItemId == eventItemId) {
        item.Selected = true;
      } else {
        item.Selected = false;
      }
    }

    this.getRegistrations();
  }

  /**
   * sets all the search and advanced search fields to default
   */
  public resetSearchForm() {
    this.searchParams.Keyword = '';
    this.searchParams.SearchAnySignUpDate = true;
    this.searchParams.SignUpStartDate = new Date();
    this.searchParams.SignUpEndDate = new Date();
    this.searchParams.AllUnpaid = false;
    this.searchParams.AllWithBlankAttendees = false;
    this.searchParams.AllWithProfileIdNotAssigned = false;

    if (this.eventItems) this.eventItems.forEach((x) => ((<any>x).Selected = false));
  }

  /**
   * resets the form and starts a fresh search
   */
  public resetAndSearch() {
    this.resetSearchForm();
    this.search();
  }

  /**
   * when the registration selector is closed for the given selectedAction
   * @param selectedAction
   */
  public handleRegistrationSelectorOkClick(selectedAction: number) {
    // confirmed for Apply Payments action
    if (selectedAction == 7) {
      this.resetAndSearch();
    }
  }

  /**
   * calls the attendee search with no filter to get total attendees for event
   */
  public updateAttendeeTotals(): void {
    let params = new RegistrationSearchParams();
    params.PageNumber = 1;
    params.PageSize = 1;
    params.EventId = this.eventId;

    this._registrationService.searchRegistrations(params).then((results) => (this.unfilteredRegistrationSearchResult = results));
  }

  /**
   * triggered by clicking "# with no profile id)
   */
  public handleAttendeesWithNoProfileIdClick(): void {
    this.searchParams.AllWithProfileIdNotAssigned = true;
    this.openAdvancedSearch();
    this.search();
  }

  public printRegistration(registration: RegistrationMin): void {
    if (!registration) return;

    var objRegistration: any = <any>registration;

    objRegistration._loadingConfirmationMessage = true;

    this._registrationService.getRegistrationConfirmationMessage(registration.Id).then(
      (message: string) => {
        if (message == null) return;

        this._platformService.openPlatformWindowToDisplayHtml(message);

        objRegistration._loadingConfirmationMessage = false;
      },
      (error) => {
        objRegistration._loadingConfirmationMessage = false;
        this._notifyService.httpError(error);
      }
    );
  }

  public goToInvoiceEdit(registration: RegistrationMin) {
    const queryParams = { tab: EventTabsEnum.Registrations };
    this._navigationService.setCurrentQueryParams(queryParams, this._route).then(() => {
      this._navigationService.navigateToInvoiceEdit(registration.InvoiceNum);
    });
  }

  private initRegistrationMenu(registration: RegistrationMin) {
    Promise.all([
      this._translationService.getTitlecase('common.delete'),
      this._translationService.getTitlecase('events.registration.management.print-registration'),
    ]).then(([deleteLabel, printRegistrationLabel]) => {
      registration._menuItems = [
        {
          label: deleteLabel,
          command: () => {
            this.deleteRegistration(registration);
          },
        },
        {
          label: printRegistrationLabel,
          command: () => {
            this.printRegistration(registration);
          },
        },
      ];
    });
  }
}
